import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ExpensesLogisticsEntity } from "./expenses-logistics-entity";
// import {Container} from  




@Entity('expenses_due_date')
export class ExpensesLogisticsUpdateEntity {
    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("int", {
        nullable: false,
        name: "expenses_logistics_id"
      })
      expensesLogisticsId: number;

    // @Column("int", {
    //     nullable: false,
    //     name: "sale_order_id"
    //   })
    //   saleOrderId: number;

  
  @Column("varchar", {
    nullable: false,
    name: "fda_due_date"
  })
  fdaDueDate: string;

  
  @Column("varchar", {
    nullable: false,
    name: "remarks"
  })
  remarks: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(
    () => ExpensesLogisticsEntity,
    (logistics) => logistics.updates
  )
  @JoinColumn({ name: 'expenses_logistics_id' })
  expensesLogistics: ExpensesLogisticsEntity;


}